export const assetUrl = (path) => `${process.env.PUBLIC_URL}/${path.replace(/^\//, '')}`;
